import { createContext } from "react";

export interface AuthContextType {
    isAuthenticated: boolean;
    user: any;
    token: string | null;
    roles: any[];
    setIsAuthenticated: (value: boolean) => void;
    setUser: (value: any) => void;
    setToken: (value: string) => void;
    setRoles: (value: any[]) => void;
}

export const AuthContext = createContext<AuthContextType | undefined>(undefined);
